var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-5",attrs:{"justify":"center"}},[_c('h2',[_vm._v("Thank you for Registration. Give us some time to create your environment.")])])}
var staticRenderFns = []

export { render, staticRenderFns }